<template>
  <van-row>
    <template v-for="(item, index) in contentList">
      <span class="text-box" :key="index" v-if="item.name === 'text'">{{ item.text }}</span>
      <img v-else-if="item.name === 'img'" :src="item.src" width="20px" height="20px" :key="index"/>
    </template>
  </van-row>
</template>

<script>
import { decodeText } from '@/utils/decodeText'

export default {
  name: 'TextElement',
  components: {
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    message: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean
    }
  },
  computed: {
    contentList() {
      return decodeText(this.payload)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .text-box{
    width: 100%;
    display: flex;
    align-items: center;
    word-break: break-all;
  }
</style>
